import { httpRequest } from '@calendly/http-tools'

import CookieService from 'services/cookie'

export const eventService = {
  /**
   * Note: Prefer using the `useTrack` hook for event tracking instead of calling `eventService.dispatch` directly.
   * This method remains available for advanced use cases.
   */
  dispatch: async ({ name, version, dependencies, entities, properties, isExternal = false }) => {
    const cookieService = new CookieService()
    const anonymousId = cookieService.getCookie('ajs_anonymous_id')
    const calAnonymousId = cookieService.getCookie('cal_anonymous_id') || null
    if (calAnonymousId != null) {
      properties.cal_anonymous_id = calAnonymousId
    }
    const [success, response] = await httpRequest({
      url: '/api/analytics/track',
      method: 'POST',
      data: {
        name,
        version,
        dependencies,
        entities,
        properties,
        anonymous_id: isExternal ? anonymousId : null,
      }
    })

    if (!success && !process.env.ENABLE_PLAYWRIGHT && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'review')) {
      alert(`Dispatching ${name} failed.\n\n${response?.payload?.message}`)
    }
  }
}
